import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=c31636e6&scoped=true&"
import script from "./Sharing.vue?vue&type=script&setup=true&lang=js&"
export * from "./Sharing.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31636e6",
  null
  
)

export default component.exports